import React from 'react';

const Avatar = ({ initials, className = "" }) => {
  // Generate consistent color based on initials
  const getColorFromInitials = (initials) => {
    const colors = [
      'from-orange-500 to-orange-600',
      'from-green-400 to-green-500',
      'from-blue-500 to-blue-600',
      'from-purple-500 to-purple-600',
      'from-pink-500 to-pink-600',
      'from-yellow-500 to-yellow-600',
    ];
    const index = initials.charCodeAt(0) % colors.length;
    return colors[index];
  };

  return (
    <div className={`flex items-center justify-center bg-gradient-to-br ${getColorFromInitials(initials)} rounded-full ${className}`}>
      <span className="text-white font-bold">
        {initials}
      </span>
    </div>
  );
};

export default Avatar;
